export default "__VITE_ASSET__DkMCTBDL__"